// getRabbitSignTemplates
export const GET_RABBIT_SIGN_TEMPLATES_START = 'GET_RABBIT_SIGN_TEMPLATES_START';
export const GET_RABBIT_SIGN_TEMPLATES_SUCCESS = 'GET_RABBIT_SIGN_TEMPLATES_SUCCESS';
export const GET_RABBIT_SIGN_TEMPLATES_FAIL = 'GET_RABBIT_SIGN_TEMPLATES_FAIL';
// saveRabbitSignTemplate
export const SAVE_RABBIT_SIGN_TEMPLATE_START = 'SAVE_RABBIT_SIGN_TEMPLATE_START';
export const SAVE_RABBIT_SIGN_TEMPLATE_SUCCESS = 'SAVE_RABBIT_SIGN_TEMPLATE_SUCCESS';
export const SAVE_RABBIT_SIGN_TEMPLATE_FAIL = 'SAVE_RABBIT_SIGN_TEMPLATE_FAIL';
// deleteRabbitSignTemplate
export const DELETE_RABBIT_SIGN_TEMPLATE_START = 'DELETE_RABBIT_SIGN_TEMPLATE_START';
export const DELETE_RABBIT_SIGN_TEMPLATE_SUCCESS = 'DELETE_RABBIT_SIGN_TEMPLATE_SUCCESS';
export const DELETE_RABBIT_SIGN_TEMPLATE_FAIL = 'DELETE_RABBIT_SIGN_TEMPLATE_FAIL';
// getRabbitSignTemplateById
export const GET_RABBIT_SIGN_TEMPLATE_BY_ID_START = 'GET_RABBIT_SIGN_TEMPLATE_BY_ID_START';
export const GET_RABBIT_SIGN_TEMPLATE_BY_ID_SUCCESS = 'GET_RABBIT_SIGN_TEMPLATE_BY_ID_SUCCESS';
export const GET_RABBIT_SIGN_TEMPLATE_BY_ID_FAIL = 'GET_RABBIT_SIGN_TEMPLATE_BY_ID_FAIL';
// validateRabbitSignSubscription
export const VALIDATE_RABBIT_SIGN_SUBSCRIPTION_START = 'VALIDATE_RABBIT_SIGN_SUBSCRIPTION_START';
export const VALIDATE_RABBIT_SIGN_SUBSCRIPTION_SUCCESS = 'VALIDATE_RABBIT_SIGN_SUBSCRIPTION_SUCCESS';
export const VALIDATE_RABBIT_SIGN_SUBSCRIPTION_FAIL = 'VALIDATE_RABBIT_SIGN_SUBSCRIPTION_FAIL';
